<!-- Accordian starts -->
<div id="{{'accordion'+accordionNo}}" class="accordion mb-3"
  attr.aria-labelledby="heading-1_{{accordionNo}}">
  <!-- Card start -->
  <div class="card" [ngClass]="{'active':expanded}">

    <button
        class="d-flex card-header justify-content-between align-items-center p-1 w-100 toggle-btn"
        id="heading-1_{{accordionNo}}"
        [ngClass]="{'collapsed':!expanded}"
        [attr.data-target]="'#collapse_'+accordionNo"
        [attr.aria-expanded]="expanded"
        [attr.aria-controls]="'collapse_'+accordionNo"
        [attr.aria-label]="title + ' accordion'"
        (click)="onArrowClicked($event)">
      <div class="col-auto pl-2 pr-0">
        <h2 class="font-bold text-capitalize mb-0 pr-2 d-inline-block title">{{title}} <small
            class="font-bold item-count">({{dataLength}})</small></h2>
        <button type="button" class="btn btn-cancel add text-underline px-1" data-toggle="modal"
          [attr.aria-label]="'Add ' + title + ' Opens in a new dialog'" [attr.data-target]="'#'+addModalId" (click)="onAddButtonClick(addModalId)"
          *ngIf="showAddButton">
          <em class="material-icons-outlined font-1x" aria-hidden="true">add</em>
        </button>
      </div>
    </button>

    <div #accordionContent id="{{'collapse_'+accordionNo}}"
      class="card collapse px-2 border-top border-right-0 border-left-0 border-bottom-0" [ngClass]="{'show': expanded}"
      [attr.data-parent]="'#accordion'+accordionNo" [attr.aria-labelledby]="'heading-1_'+accordionNo">
      <!-- line 9 - 41 to be printed here-->
      <p class="my-1" *ngIf="dataLength < 1" role="alert">
        <span class="sr-only">Error</span> Nothing added here yet.
      </p>

      <ng-content select="ng-container.accordion-content"></ng-content>

    </div>

  </div>
  <!-- Card end -->

</div>
<!-- Accordian end -->
